module.exports = __webpack_public_path__ + "img/gp_merge.ea9f7912.png";